
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ANALISA LAPANGAN</h4>
        <feather-icon icon="XIcon" @click.stop="closeSide" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <vs-row>
          <vs-col vs-align="center" class="pr-2" vs-w="6">
            <vs-select
              class="w-full"
              label="Bidang"
              v-model="dataBidang"
              @change="pilihDivisi"
              @click.prevent="changeClickDivisi"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in list_bidang"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center" class="" vs-w="6">
            <vs-select
              class="w-full"
              label="Divisi"
              v-model="dataDivisi"
              @change="pilihKelompok"
              @click.prevent="changeClickKelompok"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_divisi"/>
            </vs-select>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-align="center" class="pr-2" vs-w="6">
            <vs-select
              class="w-full"
              label="Kelompok"
              v-model="dataKelompok"
              @change="pilihSub"
              @click.prevent="changeClickSub"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_kelompok"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center" class="" vs-w="6">
            <vs-select
              class="w-full"
              label="Sub"
              v-model="dataSub"
              @change="pilihSubKode()"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_sub"/>
            </vs-select>
          </vs-col>
        </vs-row>
        
        <vs-row>
          <vs-col vs-align="left" vs-w="10">
            <vs-input label="Satuan Pekerjaan" v-model="dataAnalisa" class="w-full mt-5" name="item-analisa" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-analisa')">{{ errors.first('item-analisa') }}</span>

            <vs-textarea label="Keterangan" v-model="dataKeterangan" class="w-full mt-2" name="item-keterangan" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-keterangan')">{{ errors.first('item-keterangan') }}</span>
          </vs-col>
          <vs-col vs-align="left" vs-w="2">
            <vs-input label="Kode" v-model="dataKode" class="w-full mt-5 pl-2" name="item-kode" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-kode')">{{ errors.first('item-kode') }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-align="left" vs-w="2">
            <vs-input label="Ukuran" v-model="dataUkuran" class="w-full pr-2" name="item-ukuran" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-ukuran')">{{ errors.first('item-ukuran') }}</span>
          </vs-col>

          <vs-col vs-align="left" vs-w="6">
            <vs-select
              label="Satuan"
              v-model="dataSatuan"
              v-validate="'required'"
              class="w-full"
              >
                <vs-select-item value="0" text="Tidak ada"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSatuan"/>
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('satuan')">{{ errors.first('satuan') }}</span>
          </vs-col>
          <vs-col vs-align="left" vs-w="2">
            <vs-button class="py-3 mt-6" @click.stop="tambahSatuan=true" >+</vs-button>
          </vs-col>

          <vs-col vs-align="left" vs-w="2">
            <vs-input label="Persen" v-model="dataPersentase" @input="eventTotal()" class="w-full pr-2" name="item-persen" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-persen')">{{ errors.first('item-persen') }}</span>
          </vs-col>
        </vs-row>

        <vs-divider class="mt-base">Bahan / Barang</vs-divider>

        <!-- Bahan -->
          <vs-row class="mb-2" v-if="rowBahans.length > 0">
            <vs-col vs-align="left" vs-w="4">
              <span>Uraian</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="1">
              <span>Sat.</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="2">
              <span>Harga</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="2">
              <span>Jumlah</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="2">
              <span>Total</span>
            </vs-col>
          </vs-row>
          <vs-row id="bahan" :key="`bahan-${indexbahan}`" v-for="(bahan,indexbahan) in rowBahans" class="mb-2">

            <vs-col vs-align="left" vs-w="4" class="pr-2">
              <vs-select
                :id="`bahan-${indexbahan}`"
                v-model="bahan.task_name"
                v-validate="'required'"
                class="w-full"
                name="bahan"
                @change="pilihBahan(indexbahan, bahan.task_name)"
                >
                  <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listBahan"/>
              </vs-select>
              <input type="hidden" v-model="bahan.task_title" class="w-full pl-2" disabled />
            </vs-col>

            <vs-col vs-align="left" vs-w="1" class="mt-2">
              <span>{{bahan.term_satuan}}</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="2" class="mt-2">
              <span>{{bahan.task_price | currency}}</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="2" class="pr-2">
              <!--
              <vs-input v-model="bahan.task_quantity" class="w-full" @input="updateItemBahan(bahan.task_quantity, bahan.task_price, indexbahan)"/>
              -->
              <vs-input-number v-model="bahan.task_quantity" @input="updateItemBahan(bahan.task_quantity, bahan.task_price, indexbahan)"/>
            </vs-col>

            <vs-col vs-align="left" vs-w="2" class="mt-2">
              <input type="hidden" v-model="bahan.task_total" class="w-full" disabled />
              <span class="font-semibold">{{ bahan.task_total | currency }}</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="1" class="mt-2">
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.prevent="deleteListBahan(indexbahan)"/>
            </vs-col>
          </vs-row>

          <div class="flex flex-wrap items-center justify-between">
            <!--
            <span v-if="rowBahans.length > 0">Jumlah Harga Bahan</span>
            <span class="font-bold" v-if="rowBahans.length > 0">{{totalBahanArray | currency}}</span>
            -->
            <vs-button class="mt-2 mr-4" @click="addRowBahan">+</vs-button>
          </div>
        <!-- // Bahan -->

        <vs-divider class="mt-base"></vs-divider>
          <vs-row class="mt-4">
            <vs-col vs-align="left" vs-w="3" class="pt-2">
              <span class="font-semibold">Lama Pengerjaan</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="2">
              <vs-input-number v-model="dataHari"/>
            </vs-col>

            <vs-col vs-align="left" vs-w="3" class="pt-2">
              <span class="font-semibold">Hari</span>
            </vs-col>
          </vs-row>

        <vs-divider class="mt-base"></vs-divider>

          <div class="flex flex-wrap items-center justify-between mr-6">
            <h5>Total Harga Bahan</h5>
            <h4 class="font-bold">{{dataJumlah | currency}}</h4>
          </div>
          <div class="flex flex-wrap items-center justify-between mr-6">
            <h5>Overhead dan Profit {{dataPersentase}} %</h5>
            <h4 class="font-bold">{{dataOverhead | currency}}</h4>
          </div>
          <div class="flex flex-wrap items-center justify-between mr-6 mt-4">
            <h5 class="font-bold">Harga Satuan Pekerjaan</h5>
            <h4 class="font-bold">{{dataTotal | currency}}</h4>
          </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="closeSide">Cancel</vs-button>
    </div>

    <vs-prompt
      color="success"
      title="Tambah Satuan"
      @accept="satuanAdd"
      @close="close"
      :active.sync="tambahSatuan"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Satuan" data-vv-name="addsatuan" name="addsatuan" v-validate="'required'" v-model="addSatuan"/>
        <span class="text-danger text-sm" v-show="errors.has('addsatuan')">{{ errors.first('addsatuan') }}</span>
       </div>
    </vs-prompt>

  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default () { return { };}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {

      dataId: null,
      dataAnalisa: null,
      dataParent: 0,
      dataKode: null,
      dataUkuran: 1,
      dataSatuan: 0,
      dataPersentase: 15,
      dataOverhead: 0,
      dataJumlah: 0,
      dataTotal: 0,
      dataHari: 0,
      dataKeterangan: null,

      dataBidang: 'pilih',
      changeBidang: false,
      dataDivisi: 'pilih',
      changeDivisi: false,
      dataKelompok: 'pilih',
      changeKelompok: false,
      dataSub: 'pilih',
      changeSub: false,

      list_sub: [],
      list_bidang: [],
      list_divisi: [],
      list_kelompok: [],

      changeBahan: false,

      listSatuan: [],
      addSatuan: null,
      tambahSatuan: false,

      pilihArray: null,

      listBahan: [],
      keyrowBahans: 0,
      rowBahans: [],
      IDBahanArray: [],
      totalBahanArray: [],
      totalBahan: 0,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      },
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, task_title, kode, task_quantity, pekerjaan_sub, task_unit, task_price, task_total, task_parent, bahan, total_bahan, persentase, profit, pekerjaan_bidang, pekerjaan_divisi, pekerjaan_kelompok, hari, keterangan  } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataAnalisa = task_title
        if (task_parent != 0) {
          this.dataParent = task_parent
        } else {
          this.dataParent = id
        }
        this.dataKode = kode
        this.dataUkuran = task_quantity
        this.dataSatuan = task_unit
        this.dataPersentase = persentase

        this.dataBidang = pekerjaan_bidang
        this.dataDivisi = pekerjaan_divisi
        this.dataKelompok = pekerjaan_kelompok
        this.dataSub = pekerjaan_sub

        // pengganti overhead
        this.dataOverhead = profit

        this.dataJumlah = task_price
        this.dataTotal = task_total
        this.dataHari = hari
        this.dataKeterangan = keterangan

        for (let i=0; i < bahan.length; i++) {
          let b = this.keyrowBahans + 1
          this.rowBahans.push({
            idBahan: b,
            task_name: bahan[i].task_name,
            task_quantity: bahan[i].task_quantity,
            task_total: bahan[i].task_total,
            task_title: bahan[i].task_title,
            task_unit: bahan[i].task_unit,
            term_satuan: bahan[i].term_satuan,
            task_price: bahan[i].task_price
          })
          this.IDBahanArray.push(parseInt(bahan[i].task_name))
          //this.totalBahanArray.push(bahan[i].task_total)
          this.keyrowBahans++
        }
        this.totalBahan = total_bahan

        //this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataAnalisa && this.dataKode && this.dataUkuran && this.dataBidang && this.dataDivisi && this.dataKelompok && this.dataSub && this.dataSatuan && this.dataPersentase && this.dataOverhead && this.dataTotal && this.dataHari && this.dataKeterangan
    },
    validateSatuan() {
      return !this.errors.any() && this.addSatuan !== null
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  mounted(){
    let configs = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    this.axios.get('/term-list-sort/pekerjaan_bidang/ASC', configs).then((response) => {
      let {data} = response.data
      this.list_bidang = data
    })
    this.axios.get('/term-list-sort/satuan/ASC', configs).then((response) => {
      let {data} = response.data
      this.listSatuan = data
    })
    this.axios.get('/term-list-sort/bahan-bangunan/ASC', configs).then((response) => {
      let {data} = response.data
      this.listBahan = data
    })
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataAnalisa = null
      this.dataParent = 0
      this.dataKode = null
      this.dataUkuran = 1
      this.dataSatuan = 0
      this.dataPersentase = 15
      this.dataOverhead = 0
      this.dataTotal = 0
      this.dataHari = 0
      this.dataJumlah = 0
      this.dataKeterangan = null

      this.changeBidang = false
      this.changeDivisi = false
      this.changeKelompok = false
      this.changeSub = false
      this.dataBidang = 'pilih'
      this.dataDivisi = 'pilih'
      this.dataKelompok = 'pilih'
      this.dataSub = 'pilih'
      this.list_divisi = []
      this.list_kelompok = []
      this.list_sub = []

      this.addSatuan = null
      this.tambahSatuan = false

      this.keyrowBahans = 0
      this.rowBahans = []
      this.IDBahanArray = []
      this.totalBahanArray = []
      this.totalBahan = 0
    },
    changeClickDivisi () {
      this.changeDivisi = true
    },
    pilihDivisi () {
      this.list_divisi = []
      this.list_kelompok = []
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataBidang != 'pilih') {
        this.axios.get('/term-parent/'+this.dataBidang, configs).then((response) => {
          let {data} = response.data
          this.list_divisi = data
        })
      }
      if (this.changeDivisi === true) {
        this.dataDivisi = 'pilih'
        this.dataKelompok = 'pilih'
        this.dataSub = 'pilih'
      }
    },
    changeClickKelompok () {
      this.changeKelompok = true
    },
    pilihKelompok () {
      this.list_kelompok = []
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataDivisi != 'pilih') {
        //this.dataKelompok = 'pilih'
        this.axios.get('/term-parent/'+this.dataDivisi, configs).then((response) => {
          let {data} = response.data
          this.list_kelompok = data
        })
      }
      if (this.changeKelompok === true) {
        this.dataKelompok = 'pilih'
        this.dataSub = 'pilih'
      }
    },
    changeClickSub () {
      this.changeSub = true
    },
    pilihSub () {
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataKelompok != 'pilih') {
        this.axios.get('/term-parent/'+this.dataKelompok, configs).then((response) => {
          let {data} = response.data
          this.list_sub = data
        })
      }
      if (this.changeSub === true) {
        this.dataSub = 'pilih'
      }
    },
    searchArrayIdSub(nameKey, myArray){
      for (var i=0; i < myArray.length; i++) {
        if (myArray[i].id === nameKey) {
          return myArray[i];
        }
      }
    },
    pilihSubKode () {
      if (this.changeSub === true) {
        let sub = this.searchArrayIdSub(this.dataSub, this.list_sub)
        this.dataKode = sub.kode + '.'
      }
    },
    satuanAdd() {
      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addSatuan,
        term_group: 0,
        parent: 0,

        taxonomy: 'satuan'
      }
      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listSatuan = []
        this.addSatuan = null
        this.loadSatuan()
        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Satuan telah bertambah',
        })
        this.$vs.loading.close()
      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    loadSatuan () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/satuan', configs)
      .then((response) => {
        let {data} = response.data
        this.listSatuan = data
      })
      .catch((error) => {
        let data = error.data
        this.listSatuan = data
      })
    },
    //Bahan
      searchArrayIdBahan(nameKey, myArray){
        for (var i=0; i < myArray.length; i++) {
          if (myArray[i].id === nameKey) {
            return myArray[i];
          }
        }
      },
      reduceBahan(total, num) {
        return total + num;
      },
      addRowBahan() {
        this.changeBahan = true
        document.createElement('vs-row')
        let c = this.keyrowBahans + 1;
        this.rowBahans.push({
          idBahan: c,
          task_name: 0,
          task_quantity: 0,
          task_total: 0,
          task_title: null,
          task_unit: null,
          term_satuan: null,
          task_price: null
        });
        this.keyrowBahans++
      },
      pilihBahan(indexbahan, id) {
        if (this.changeBahan === true) {
          if (this.IDBahanArray.includes(id) === true) {
            this.rowBahans.splice(indexbahan)
            this.$vs.notify({
              title: 'Sudah ada',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right',
              time: 4000
            })
            this.IDBahanArray.splice(indexbahan)
          } else {
            this.IDBahanArray.splice(indexbahan)
            let bahan = this.searchArrayIdBahan(id, this.listBahan)
            this.IDBahanArray.push(id)
            this.totalBahanArray.splice(indexbahan)
            this.rowBahans[indexbahan].task_title = bahan.name
            this.rowBahans[indexbahan].task_total = 0
            this.rowBahans[indexbahan].task_quantity = 0
            this.rowBahans[indexbahan].task_price = bahan.harga
            this.rowBahans[indexbahan].term_satuan = bahan.namasatuan
            this.rowBahans[indexbahan].task_unit = bahan.satuan
            /*
            if (this.totalBahanArray.length != 0 ) {
              this.totalBahan = this.totalBahanArray.reduce(this.reduceBahan)
            } else {
              this.totalBahan = 0
            }
            */
          }
        }
      },
      updateItemBahan (event, price, indexbahan) {
        let tambahHarga = Math.abs(event * price)
        this.rowBahans[indexbahan].task_total = tambahHarga
        /*
        this.totalBahanArray.splice(indexbahan, 1)
        this.totalBahanArray.push(this.rowBahans[indexbahan].task_total)
        this.totalBahan = this.totalBahanArray.reduce(this.reduceBahan)
        */
        this.totalBahan = 0
        for(var i = 0, len = this.rowBahans.length; i < len; i++) {
          this.totalBahan += this.rowBahans[i].task_total;
        }
        this.eventTotal()
      },
      deleteListBahan (indexbahan) {
        this.rowBahans.splice(indexbahan, 1)
        this.IDBahanArray.splice(indexbahan,1)
        /*
        this.totalBahanArray.splice(indexbahan,1)
        if (this.totalBahanArray.length > 0) {
          this.totalBahan = this.totalBahanArray.reduce(this.reduceBahan)
          this.eventTotal()
        }
        */
        this.totalBahan = 0
        for(var i = 0, len = this.rowBahans.length; i < len; i++) {
          this.totalBahan += this.rowBahans[i].task_total;
        }
        this.eventTotal()
        this.changeBahan = false
      },
    close() {
      this.$emit('closed', false)
    },
    closeSide() {
      this.initValues()

      this.changeBidang = false
      this.changeDivisi = false
      this.changeKelompok = false
      this.changeSub = false
      this.dataBidang = 'pilih'
      this.dataDivisi = 'pilih'
      this.dataKelompok = 'pilih'
      this.dataSub = 'pilih'
      //this.list_bidang = []
      this.list_divisi = []
      this.list_kelompok = []
      this.list_sub = []

      this.keyrowBahans = 0
      this.rowBahans = []
      this.IDBahanArray = []
      this.totalBahanArray = []
      this.totalBahan = 0

      this.initValues()
      this.isSidebarActiveLocal = false
    },
    eventTotal () {
      this.dataJumlah = parseFloat(this.totalBahan)
      this.dataOverhead = parseFloat(this.dataPersentase) * this.dataJumlah / 100
      this.dataTotal = parseFloat(this.dataJumlah) + parseFloat(this.dataOverhead)
    },
    submitData () {
      this.$vs.loading()
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {

            id: this.dataId,
            task_title: this.dataAnalisa,
            task_total: this.dataTotal,
            task_unit: this.dataSatuan,
            task_price: this.dataJumlah,
            task_quantity: this.dataUkuran,
            task_parent: this.dataParent,
            task_type: 'perencanaan',
            task_sub_type: 'analisa',
            task_status: 'publish',
            task_group: 'lapangan',
            comment_status: 'null',
            task_password: 'null',

            meta : {
              persentase: this.dataPersentase,
              overhead: this.dataOverhead,
              kode: this.dataKode,
              hari: this.dataHari,
              keterangan: this.dataKeterangan
            },

            relations: {
              pekerjaan_bidang: this.dataBidang,
              pekerjaan_divisi: this.dataDivisi,
              pekerjaan_kelompok: this.dataKelompok,
              pekerjaan_sub: this.dataSub
            },

            bahan: this.rowBahans

          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('analisa/updateAnalisa', obj)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          } else {
            delete obj.id
            this.$store.dispatch('analisa/addAnalisa', obj)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
          this.changeBidang = false
          this.changeDivisi = false
          this.changeKelompok = false
          this.changeSub = false
          this.dataBidang = 'pilih'
          this.dataDivisi = 'pilih'
          this.dataKelompok = 'pilih'
          this.dataSub = 'pilih'
          //this.list_bidang = []
          this.list_divisi = []
          this.list_kelompok = []
          this.list_sub = []

          this.keyrowBahans = 0
          this.rowBahans = []
          this.IDBahanArray = []
          this.totalBahanArray = []
          this.totalBahan = 0

          this.initValues()
          this.$emit('closeSidebar')
        }
      })
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 750px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
